import {fetcher} from 'src/global/fetcher';

const prefix = 'auth';
export const LoginServices = {
  login: (data: {username: string; password: string}) =>
    fetcher.post(`${prefix}/login`, data),
  logout: () => fetcher.get(`${prefix}/logout`),
};
